import { useMutation } from "@apollo/client";
import {
  Box,
  Flex,
  Text,
  Button,
  Stack,
  useColorModeValue,
  useDisclosure,
  useMediaQuery,
  ModalFooter,
  useToast,
} from "@chakra-ui/react";
import { capitalize, set } from "lodash";

import { ReactNode } from "react";
import { Link } from "react-router-dom";
import ModalWrapper from "../../components/modals/ModalWrapper";
import {
  CREATE_USER,
  REQEUST_ACCOUNT,
} from "../../components/modals/user/create/mutations";
import RegisterForm from "../../components/modals/user/create/Register";

type PublicProps = {
  children: ReactNode;
};

export default function PublicLayout(props: PublicProps) {
  const {
    isOpen: isRequestModalOpen,
    onOpen: onOpenRequestModal,
    onClose: onCloseRequestModal,
  } = useDisclosure();
  const toast = useToast();

  const [createUser, { loading }] = useMutation(REQEUST_ACCOUNT);

  const onSubmit = (values: any) => {
    set(values, "isRequest", true);
    set(values, "role", "ESTABLISHMENT");

    console.log("values", values);
    return createUser({
      variables: {
        inputs: [values],
      },
    })
      .then((data: any) => {
        if (data) {
          onCloseRequestModal();
          if (!toast.isActive("active-toast")) {
            toast({
              id: "active-toast",
              title: "Succesfully created",
              description: `${capitalize(
                data?.data.accountRegister[0].name
              )} was created, please wait for your account confirmation`,
              status: "success",
              duration: 3000,
              isClosable: true,
              variant: "solid",
            });
          }
        }
      })
      .catch((error) => {});
  };

  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Box>
      <Flex
        p={isLargerThan900 ? "6" : "4"}
        bg="primary"
        color={useColorModeValue("gray.600", "white")}
        minH={"60px"}
        borderBottom={1}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.900")}
      >
        <Flex flex={{ base: 1 }}>
          <Text fontSize="2xl" fontWeight="bold" color="white">
            FreeshU
          </Text>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={"flex-end"}
          direction={"row"}
          spacing={6}
        >
          <Button
            fontSize={"sm"}
            fontWeight="bold"
            color="white"
            variant={"link"}
            as={Link}
            to="/about"
          >
            About
          </Button>
          <Button
            fontSize={"sm"}
            fontWeight="bold"
            color="white"
            variant={"link"}
            onClick={onOpenRequestModal}
          >
            Request Account
          </Button>
          <Button
            as={Link}
            to="/auth"
            display={{ base: "none", md: "inline-flex" }}
            bg={"green.500"}
            fontWeight="bold"
            color="white"
            _hover={{
              bg: "green.200",
            }}
          >
            Sign In
          </Button>
        </Stack>
      </Flex>
      <Box p={isLargerThan900 ? "4" : "1"}>{props.children}</Box>

      <ModalWrapper
        onClose={onCloseRequestModal}
        onOpen={onOpenRequestModal}
        isOpen={isRequestModalOpen}
        title="Request Account"
      >
        <RegisterForm onSubmit={onSubmit} />

        <ModalFooter>
          <Button
            mr="3"
            w={isLargerThan900 ? "50" : "full"}
            onClick={onCloseRequestModal}
          >
            Cancel
          </Button>
          <Button
            w={isLargerThan900 ? "50" : "full"}
            form={"registerAccount"}
            colorScheme="whatsapp"
            type="submit"
            isLoading={loading}
            isDisabled={loading}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalWrapper>
    </Box>
  );
}
